import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const steps = [
  "Choisir la devise et l’opération",
  "Saisir le montant",
  "Saisir vos coordonnées",
  "Terminé",
];

export default function Steeper() {
  const state=useSelector((state)=>state.reservation.value);
  return (
    <Box
      sx={{
        width: "100%",
        padding:1,
      }}
    >
      <Stepper activeStep={state.steep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>
                <Typography variant="body2" >
                {label}
                </Typography>
                </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
